import './App.css';

function App() {
  return (
    <div className="App">
      <iframe title="game-wrapper" src="/GAME/index.html"></iframe>
    </div>
  );
}

export default App;
